var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 238.933,
    height: 36.175,
    viewBox: "0 0 238.933 36.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.647,
    y1: 1.462,
    x2: -0.778,
    y2: -0.395,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f9cd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed0f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.516,
    y1: 1.491,
    x2: 0.335,
    y2: -0.425,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.948,
    y1: 1.491,
    x2: 2.955,
    y2: -0.425,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.632,
    y1: 1.491,
    x2: 1.362,
    y2: -0.425,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199",
    transform: "translate(92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2617",
    "data-name": "Group 2617",
    transform: "translate(-92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M689.644,118.538a4.664,4.664,0,1,1-4.664,4.663A4.664,4.664,0,0,1,689.644,118.538Z",
    transform: "translate(-455.375 -91.691)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(106.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M609.34,79.46c-9.157,0-13.9-3.851-14.1-11.445l-.007-.276h7.295l.018.249c.252,3.463,2.475,5.146,6.794,5.146,2.637,0,4.467-.505,5.441-1.5a3.2,3.2,0,0,0,.863-2.441c0-1.519-.963-2.526-2.943-3.082-2.026-.588-4.3-1.215-6.764-1.863-6.772-1.726-10.207-4.95-10.207-9.58.132-7.276,4.47-10.963,12.892-10.963h.23c8.173,0,12.521,3.65,12.921,10.849l.016.284H617.58a3.547,3.547,0,0,1-3.38-2.111c-1.11-1.848-3.112-2.794-5.939-2.794-3.456.063-5.2,1.295-5.323,3.766,0,1.991,2.173,3.487,6.46,4.432a84.238,84.238,0,0,1,8.171,2.362c3.9,1.346,5.779,4.274,5.577,8.7C622.746,76.008,618.1,79.46,609.34,79.46Z",
    transform: "translate(-504.079 -43.704)",
    fill: "#2e9bd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M509.732,80.023V49.246a3.846,3.846,0,0,1,1.1-2.736,3.6,3.6,0,0,1,2.7-1.162h12.557c3.511,0,6.241.745,8.112,2.216a8.19,8.19,0,0,1,2.85,6.686,9.819,9.819,0,0,1-1.009,4.436,7.271,7.271,0,0,1-2.754,2.6,8.15,8.15,0,0,1,3.622,2.924,9.014,9.014,0,0,1,1.319,5.15c0,3.4-1.122,6.049-3.336,7.86-2.195,1.862-5.356,2.807-9.392,2.807ZM525.01,73.3a7.03,7.03,0,0,0,4.157-1.027,3.727,3.727,0,0,0,1.165-3.118,4.025,4.025,0,0,0-1.18-3.228,7.241,7.241,0,0,0-4.241-1.015h-7.775V73.3Zm-.294-14.715a7.835,7.835,0,0,0,3.675-.838,3.219,3.219,0,0,0,1.059-2.62A2.934,2.934,0,0,0,528.38,52.6a6.479,6.479,0,0,0-3.763-.829h-7.48V58.59Z",
    transform: "translate(-449.253 -44.758)",
    fill: "#2e9bd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M341.153,80.023V49.246a3.846,3.846,0,0,1,1.1-2.736,3.6,3.6,0,0,1,2.7-1.162h3.7v27.86h16.677v6.816Z",
    transform: "translate(-341.153 -44.758)",
    fill: "#2e9bd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M437.263,80.023l-2.256-6.965H422.156L419.9,80.023h-8.033l11.508-32.241a3.451,3.451,0,0,1,3.589-2.435h5.781L445.2,80.023Zm-4.392-13.291-4.339-13.377-4.339,13.377Z",
    transform: "translate(-386.497 -44.758)",
    fill: "#2e9bd9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(0.269 0.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(91.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M617.976,61.229a83.693,83.693,0,0,0-8.142-2.355q-6.671-1.471-6.671-4.709.2-3.924,5.592-4.022,4.414,0,6.18,2.943a3.281,3.281,0,0,0,3.139,1.962H622q-.589-10.594-12.654-10.594-12.655-.1-12.851,10.693,0,6.769,10.006,9.319,3.728.981,6.769,1.864,3.139.883,3.139,3.335.1,4.218-6.572,4.218t-7.063-5.4H596q.294,11.184,13.832,11.183,12.949,0,13.537-10.006Q623.666,63.191,617.976,61.229Z",
    transform: "translate(-596.002 -44.454)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M617.976,61.229a83.693,83.693,0,0,0-8.142-2.355q-6.671-1.471-6.671-4.709.2-3.924,5.592-4.022,4.414,0,6.18,2.943a3.281,3.281,0,0,0,3.139,1.962H622q-.589-10.594-12.654-10.594-12.655-.1-12.851,10.693,0,6.769,10.006,9.319,3.728.981,6.769,1.864,3.139.883,3.139,3.335.1,4.218-6.572,4.218t-7.063-5.4H596q.294,11.184,13.832,11.183,12.949,0,13.537-10.006Q623.666,63.191,617.976,61.229Z",
    transform: "translate(-596.002 -44.454)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(60.479 0.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M533.144,61.793a7.276,7.276,0,0,0,3.139-2.747,9.516,9.516,0,0,0,.981-4.317,7.9,7.9,0,0,0-2.747-6.474Q531.77,46.1,526.571,46.1H514.014a3.328,3.328,0,0,0-2.5,1.079,3.57,3.57,0,0,0-1.03,2.55V80.235h15.5q5.984,0,9.221-2.747,3.237-2.649,3.237-7.652a8.723,8.723,0,0,0-1.275-5A8.154,8.154,0,0,0,533.144,61.793Zm-15.794-9.81h7.75a6.679,6.679,0,0,1,3.924.883,3.21,3.21,0,0,1,1.177,2.747,3.493,3.493,0,0,1-1.177,2.845,8.05,8.05,0,0,1-3.826.883H517.35Zm12.458,20.993a7.247,7.247,0,0,1-4.316,1.079H517.35V65.128h8.044a7.447,7.447,0,0,1,4.414,1.079,4.258,4.258,0,0,1,1.275,3.434A3.956,3.956,0,0,1,529.808,72.976Z",
    transform: "translate(-510.483 -46.097)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M533.144,61.793a7.276,7.276,0,0,0,3.139-2.747,9.516,9.516,0,0,0,.981-4.317,7.9,7.9,0,0,0-2.747-6.474Q531.77,46.1,526.571,46.1H514.014a3.328,3.328,0,0,0-2.5,1.079,3.57,3.57,0,0,0-1.03,2.55V80.235h15.5q5.984,0,9.221-2.747,3.237-2.649,3.237-7.652a8.723,8.723,0,0,0-1.275-5A8.154,8.154,0,0,0,533.144,61.793Zm-15.794-9.81h7.75a6.679,6.679,0,0,1,3.924.883,3.21,3.21,0,0,1,1.177,2.747,3.493,3.493,0,0,1-1.177,2.845,8.05,8.05,0,0,1-3.826.883H517.35Zm12.458,20.993a7.247,7.247,0,0,1-4.316,1.079H517.35V65.128h8.044a7.447,7.447,0,0,1,4.414,1.079,4.258,4.258,0,0,1,1.275,3.434A3.956,3.956,0,0,1,529.808,72.976Z",
    transform: "translate(-510.483 -46.097)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(0 0.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M348.868,46.1h-3.434a3.328,3.328,0,0,0-2.5,1.079,3.57,3.57,0,0,0-1.03,2.55V80.235h23.641V73.957H348.868Z",
    transform: "translate(-341.903 -46.097)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M348.868,46.1h-3.434a3.328,3.328,0,0,0-2.5,1.079,3.57,3.57,0,0,0-1.03,2.55V80.235h23.641V73.957H348.868Z",
    transform: "translate(-341.903 -46.097)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(25.482 0.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M433.237,46.1h-5.592a3.192,3.192,0,0,0-3.335,2.256L412.931,80.235h7.455l2.256-6.965h13.243l2.256,6.965H445.5Zm-8.731,21.385,4.709-14.519,4.709,14.519Z",
    transform: "translate(-412.931 -46.097)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M433.237,46.1h-5.592a3.192,3.192,0,0,0-3.335,2.256L412.931,80.235h7.455l2.256-6.965h13.243l2.256,6.965H445.5Zm-8.731,21.385,4.709-14.519,4.709,14.519Z",
    transform: "translate(-412.931 -46.097)",
    fill: "url(#linear-gradient-7)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M190.4,44.454v9.357h13.155c8.49,0,9.447,6.338,9.447,8.251s-1.794,8.61-7.534,8.61h-24.4l-10.763,9H205.95c7.773,0,16.383-6.727,16.383-17.609s-8.371-17.609-17.579-17.609Z",
    transform: "translate(-125.35 -44.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M100.708,44.454V56.562L72.725,80.24,54.189,64.574V80.24H44.981V44.454l27.744,23.23Z",
    transform: "translate(-44.981 -44.185)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/md.dd48736abdea7adf52abada7c3bbb9e3.svg";
export { ForwardRef as ReactComponent };